import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';
import { APP_VERSION } from 'src/environments/version';
import { UserSite } from '../auth/auth.models';

@Injectable({
  providedIn: 'root',
})
export class AppInsightsService {
  private appInsights: ApplicationInsights | null = null;

  private userSite: UserSite | undefined = undefined;
  private trackPageView = false;
  constructor(public router: Router) {}

  init(instrumentationKey: string, trackPageView: boolean) {
    this.trackPageView = trackPageView;
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: instrumentationKey,
        enableAutoRouteTracking: trackPageView,
      },
    });

    this.appInsights.loadAppInsights();
    console.log('appInsights loaded');

    this.appInsights.context.application.ver = APP_VERSION;

    this.addUserDataInitializer();
    this.addTelemetryFilterInitializer();
  }

  setUserData(userId?: number, userSite?: UserSite) {
    if (userId) {
      this.appInsights?.setAuthenticatedUserContext(userId.toString(), '', true);
    } else {
      this.appInsights?.clearAuthenticatedUserContext();
    }

    this.userSite = userSite;
  }

  clearUserData() {
    this.appInsights?.clearAuthenticatedUserContext();
  }

  logPageView(name?: string, url?: string) {
    if (!this.trackPageView) return;

    this.appInsights!.trackPageView({
      name: name,
      uri: url,
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    this.appInsights!.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    this.appInsights!.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number) {
    this.appInsights!.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    this.appInsights!.trackTrace({ message: message }, properties);
  }

  private addUserDataInitializer() {
    this.appInsights?.addTelemetryInitializer((item) => {
      if (!item.data || !this.userSite) return;

      item.data = item.data || {};
      item.data.SiteCDPF = this.userSite?.cdpf;
      item.data.SiteName = this.userSite?.name;
    });
  }

  private addTelemetryFilterInitializer() {
    this.appInsights?.addTelemetryInitializer((item) => {
      if (item.baseType === 'RemoteDependencyData') {
        const dependencyData = item.baseData;
        const name = dependencyData?.name || '';
        const target = dependencyData?.target || '';

        // On retourne toujours tout ce qui concerne notre API
        if (name.includes(environment.apiUrl)) return true;

        // Filtrer les assets statiques
        if (name.includes('/assets/') || name.match(/\.(svg|js|css|map|json|png|jpg|jpeg|gif|woff|woff2|ttf|ico)(\?|$)/i)) return false;

        // Filtrer Google Analytics
        if (name.includes('google-analytics.com') || target.includes('google-analytics.com')) return false;
      }

      return true;
    });
  }
}
